const Strings = {
  dignosisReport: "ALS/MND Diagnosis Report",
  changePassword: "Change Password",
  speechParticipants: "Speech Participants",
  radcliffParticipants: "Radcliff Participants",
  viewAlsfrs: "View ALSFRS-R",
  ecasSessions: "ECAS Sessions",
  consortiaRequests: "Consortia Requests",
  addConsortiaRequest: "New Request",
  contentLibrary: "Content Library",
  consortiaKnowledgebase: "Consortia Workspace",
  eventCalender: "Events Calendar",
  speechStudy: "Speech Study",
  radcliffStudy: "The Radcliff Study",
  ecasStudy: "ECAS",
  realTimeStatastics: "REAL TIME STUDY STATISTICS",
  allParticipantDemographicsDistribution:
    "All Participants Demographics Distribution",
  radcliffCumulative: "Radcliff - Cumulative",
  radcliffCumulativeSubHeading: "Cumulative Enrolled, Active and Withdrawn",
  consortaiUploadList: "Consortia Uploads",
  consortaiUploadAdd: "New Consortia Upload",
  consortaiUploadEdit: "Edit Consortia Upload",
};
export default Strings;
